<div class="custom-modal-layout">
    <div class="modal-header">
        <div class="icon">
            <img src="icons/plus-circle.svg" alt="Email Icon" />
        </div>
        <span class="title">Adicionar nova vaga</span>
        <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()" />
    </div>
    <form [formGroup]="addConcursoForm" (ngSubmit)="save()">

        <p-stepper [(value)]="activeStep" class="basis-[50rem]">
            <p-step-list>
                <p-step [value]="1">
                    <ng-template #content let-activateCallback="activateCallback" let-value="value">
                        <a class="step-indicator" [class.active]="value==activeStep" (click)="activateCallback(1)">
                            <div class="number">1</div>
                            <div class="label">
                                Informações iniciais
                            </div>
                        </a>
                    </ng-template>
                </p-step>
                <p-step [value]="2">
                    <ng-template #content let-activateCallback="activateCallback" let-value="value">
                        <a class="step-indicator" [class.active]="value==activeStep" (click)="activateCallback(2)">
                            <div class="number">2</div>
                            <div class="label">
                                Modelo e remuneração
                            </div>
                        </a>
                    </ng-template>
                </p-step>
            </p-step-list>
            <p-step-panels>
                <p-step-panel [value]="1">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="p-fluid grid">

                            <div class="field col-4">
                                <label for="codigoISCO">Sub-sector</label>
                                <p-select id="province" class="w-full" [options]="subsector" optionLabel="designacao"
                                    (onChange)="onChangeSector($event)" optionValue="id" appendTo="body"
                                    placeholder="Seleccione o sub-sector" />
                            </div>
                            <div class="field col-8">
                                <label for="profissaoCatalogoID">Profissão Catálogo ID</label>
                                <p-select id="province" class="w-full" [options]="listaProfissoes" [filter]="true"
                                    filterBy="designacaoISCO" optionLabel="designacaoISCO" optionValue="id"
                                    formControlName="profissaoCatalogoID" appendTo="body"
                                    emptyFilterMessage="Nenhum resultado encontrado"
                                    emptyMessage="Nenhum resultado encontrado"
                                    placeholder="Pesquise a profissão no catálogo">
                                    <ng-template #selectedItem let-selectedProfissao #item>
                                        <div class="flex items-center gap-2">
                                            <div>
                                                {{selectedProfissao.codigoISCO}} - {{selectedProfissao.designacaoISCO}}
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template let-profissao #item>
                                        <div class="flex items-center gap-2">
                                            <div>{{ profissao.codigoISCO }} - {{ profissao.designacaoISCO }}</div>
                                        </div>
                                    </ng-template>
                                </p-select>
                            </div>

                            <div class="field col-6">
                                <label for="numVaga">Número de Vagas</label>
                                <input id="numVaga" type="number" class="w-full" pInputText formControlName="numVaga"
                                    placeholder="Informe o número de vagas" />
                            </div>

                            <div class="field col-6">
                                <label for="dataEncerramento">Data de Encerramento</label>
                                <p-datepicker id="dataEncerramento" class="w-full" [showIcon]="true" appendTo="body" dateFormat="dd/mm/yy"
                                    placeholder="Seleccione a data de encerramento"
                                    formControlName="dataEncerramento"></p-datepicker>
                            </div>

                            <div class="field col-12">
                                <label for="localizacao">Localização</label>
                                <p-iconfield class="w-100">
                                    <p-inputicon styleClass="pi pi-map-marker" />
                                    <input id="localizacao" type="text" formControlName="localizacao" class="w-100"
                                        pInputText placeholder="Localização da vaga" />
                                </p-iconfield>
                            </div>

                            <div class="field col-12">
                                <label for="descricao">Descrição</label>
                                <textarea id="descricao" class="w-full" rows="4" pInputTextarea
                                    formControlName="descricao" placeholder="Descreva a vaga"></textarea>
                            </div>

                        </div>
                    </ng-template>
                </p-step-panel>
                <p-step-panel [value]="2">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="p-fluid grid">

                            <div class="field col-6">
                                <label for="tipoContrato">Tipo de Contrato</label>
                                <p-select id="tipoContrato" class="w-full" [options]="tipoContratoOptions"
                                    formControlName="tipoContrato"
                                    placeholder="Seleccione o tipo de contrato"></p-select>
                            </div>

                            <div class="field col-6">
                                <label for="nivelHabilitacao">Nível de Habilitação</label>
                                <p-select id="nivelHabilitacao" class="w-full" [options]="nivelHabilitacaoOptions"
                                    formControlName="nivelHabilitacao"
                                    placeholder="Seleccione o nível de habilitação"></p-select>
                            </div>

                            <div class="field col-6">
                                <label for="anoExperiencia">Anos de Experiência</label>
                                <p-select id="anoExperiencia" class="w-full" [options]="anosExperienciaOptions"
                                    formControlName="anoExperiencia"
                                    placeholder="Informe os anos de experiência"></p-select>
                            </div>

                            <div class="field col-6">
                                <label for="regimeTrabalho">Regime de Trabalho</label>
                                <p-select id="regimeTrabalho" class="w-full" [options]="regimeTrabalhoOptions"
                                    formControlName="regimeTrabalho"
                                    placeholder="Seleccione o regime de trabalho"></p-select>
                            </div>

                            <div class="field col-12">
                                <label for="remuneracao">Remuneração USD (mensal)</label>
                                <p-iconfield class="w-100">
                                    <p-inputicon styleClass="pi pi-money-bill" />
                                    <p-inputnumber inputId="remuneracao" mode="currency" currency="USD" locale="en-US"
                                        formControlName="remuneracao" />
                                </p-iconfield>
                            </div>

                        </div>

                    </ng-template>
                </p-step-panel>
            </p-step-panels>
        </p-stepper>

        <div class="d-flex justify-content-between mt-4">
            <button pButton type="button" label="Voltar" class="p-button-secondary" (click)="prevStep()"></button>
            @if (activeStep != 2) {
            <button pButton type="button" label="Próximo" class="p-button-primary" (click)="nextStep()"></button>
            } @else {
            <button pButton type="submit" label="Guardar" class="p-button-primary"></button>
            }
        </div>
    </form>
</div>